import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { t as translate, TRANSLATIONS, RTL_LANGS } from "./translations";
import { getLangFromPath, stripLang, withLang } from "./langPath";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const urlLang = getLangFromPath(location.pathname);
  const [lang, setLangState] = useState(urlLang);

  useEffect(() => {
    if (urlLang !== lang) setLangState(urlLang);
    localStorage.setItem("sl_lang", urlLang);
    document.documentElement.lang = urlLang;
    document.documentElement.dir = RTL_LANGS.includes(urlLang) ? "rtl" : "ltr";
  }, [urlLang]); // eslint-disable-line react-hooks/exhaustive-deps

  // Changing language navigates to the same page under the new language prefix.
  const setLang = useCallback(
    (code) => {
      const { path } = stripLang(location.pathname);
      navigate(withLang(path, code) + location.hash);
    },
    [location.pathname, location.hash, navigate]
  );

  const t = useCallback((key, vars) => translate(lang, key, vars), [lang]);
  const tList = useCallback((key) => {
    const l = TRANSLATIONS[lang] || TRANSLATIONS.de;
    return l[key] || TRANSLATIONS.de[key] || [];
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, tList }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: "de", setLang: () => {}, t: (k) => translate("de", k), tList: (k) => TRANSLATIONS.de[k] || [] };
  return ctx;
}
